import { Department } from './index'
import {
  SelectedDepartmentWrapper,
  PathAndName,
  SelectedDepartmentPathContainer,
  SelectedDepartmentName,
  Path,
} from './Styles'
interface SelectedDepartmentProps {
  canRemove?: boolean
  department: Department
  deselect: () => void
}
import { ReactComponent as DeleteIcon } from '@/assets/images/icons/general/x-close.svg'

export default function SelectedDepartment({
  canRemove = true,
  department,
  deselect,
}: SelectedDepartmentProps) {
  const name = department.name || ''
  const fullPath = department.path
  const parentName = department.parentDepartment?.name || ''

  const handleDeselect = () => {
    if (canRemove) {
      deselect()
    }
  }

  return (
    <SelectedDepartmentWrapper onClick={handleDeselect}>
      <PathAndName>
        {(fullPath || parentName) && (
          <SelectedDepartmentPathContainer>
            {fullPath && <Path title={fullPath}>{fullPath}</Path>}
          </SelectedDepartmentPathContainer>
        )}
        <SelectedDepartmentName title={name}>{name}</SelectedDepartmentName>
      </PathAndName>
      {canRemove && (
        <DeleteIcon
          onClick={handleDeselect}
          style={{
            cursor: 'pointer',
            height: '15px',
            width: '15px',
            margin: '0px 4px',
          }}
        />
      )}
    </SelectedDepartmentWrapper>
  )
}
